import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { emailPattern, mobilePattern, noWhitespaceInRequiredValidator } from '../../shared/constants';
import { map, Observable, startWith } from 'rxjs';
import { NgxFileDropEntry } from 'ngx-file-drop';

@Component({
	selector: 'app-mail-status',
	templateUrl: './mail-status.component.html',
	styleUrl: './mail-status.component.scss'
})
export class MailStatusComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/company",
			name: "Companies"
		}
	];
	compId: any = null;
	companyDetails: any = null;
	pageLoading1 = false;
	pageLoading2 = false;
	accessLoader = false;
	user_type: any = "";
	mailStatus: any = {};

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe({
			next: (data: any) => {
				this.accessLoader = false;
				try {
					this.user_type = data.res[0].user_type;
				} catch (error) { }
			}, error: (error: any) => {
				this.accessLoader = false;
			}
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.compId = routeParams["compId"];
			this.breadcrumbList.push({ path: "/app/mail-status/" + this.compId, name: "Mail Status" });
			this.getDetails();
			this.getMailStatus();
		});
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getCompanyDetails({ "id": this.compId }).subscribe({
			next: (data: any) => {
				this.companyDetails = data.data;
				this.pageLoading1 = false;
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getMailStatus() {
		this.pageLoading2 = true;
		this.apiService.getMailStatusList({ "id": this.compId }).subscribe({
			next: (data: any) => {
				this.mailStatus = data;
				this.pageLoading2 = false;
			}, error: (error) => {
				this.mailStatus = {};
				this.pageLoading2 = false;
				if (error.status == 401) { return }
			}
		});
	}

	getStatus(status: any) {
		try {
			return status.map((st) => st.toUpperCase()).join(", ");
		} catch (error) {
			return status;
		}
	}

	formatTimestamp(isoString) {
		const date = new Date(isoString);

		/* Add the specified hours and minutes */
		date.setUTCHours(date.getUTCHours() + 5);
		date.setUTCMinutes(date.getUTCMinutes() + 30);

		const day = String(date.getUTCDate()).padStart(2, '0');
		const month = String(date.getUTCMonth() + 1).padStart(2, '0');
		const year = date.getUTCFullYear();
		const hours = String(date.getUTCHours()).padStart(2, '0');
		const minutes = String(date.getUTCMinutes()).padStart(2, '0');

		return `${day}-${month}-${year} ${hours}:${minutes}`;
	}
}
